/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import {
  Container, Title, Content, ImageContainer, Image,
} from './content-block-css';
import { ButtonContainer, Button, ButtonText } from '../button/button';
import ParentState from '../../contexts/parent-component';

const ContentBlock = ({
  title, media, mediaPosition, spaceAdjustment, backgroundColor, parent, callToActionList, children,
}) => (
  <Container
    mediaPosition={mediaPosition}
    spaceAdjustment={spaceAdjustment}
    bg={backgroundColor}
    fluid={mediaPosition && mediaPosition.includes('Background') && media ? media.fluid : undefined}
  >
    {media && mediaPosition && !mediaPosition.includes('Background') && (
      <ImageContainer mediaPosition={mediaPosition}>
        <Image
          fluid={media.fluid}
          alt={media.title}
          mediaPosition={mediaPosition}
        />
      </ImageContainer>
    )}
    <Content
      mediaPosition={mediaPosition}
      bg={backgroundColor}
      parentType={parent && parent.type}
      hasMedia={media !== null}
    >
      {title && <Title bg={backgroundColor}>{title}</Title>}
      <ParentState backgroundColor={backgroundColor}>
        {children}
      </ParentState>
      {callToActionList && (
        <ButtonContainer>
          {callToActionList.map(({ text, link }) => {
            const { page, pageSection, pagePaths } = link;
            const paths = page ? page.pagePaths : pagePaths;
            const sectionFragment = pageSection ? `#${slugify(pageSection.title, { lower: true })}` : '';
            const url = paths ? `${paths[0].path}${sectionFragment}` : link.url;
            return (
              <Button to={url} key={text}>
                <ButtonText>{text}</ButtonText>
              </Button>
            );
          })}
        </ButtonContainer>
      )}
    </Content>
  </Container>
);

ContentBlock.propTypes = {
  title: PropTypes.string,
  media: PropTypes.shape({
    fluid: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
  }),
  mediaPosition: PropTypes.oneOf(['Background - Fixed Height', 'Background - Full Width', 'Background - Flexible Height', 'Right']),
  spaceAdjustment: PropTypes.oneOf(['Add Bottom Padding']),
  backgroundColor: PropTypes.string,
  parent: PropTypes.shape({
    type: PropTypes.string,
  }),
  callToActionList: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.shape({
      pagePaths: PropTypes.arrayOf(PropTypes.shape({
        path: PropTypes.string.isRequired,
      })),
      url: PropTypes.string,
    }).isRequired,
  })),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ContentBlock.defaultProps = {
  title: '',
  media: null,
  mediaPosition: null,
  spaceAdjustment: null,
  backgroundColor: undefined,
  parent: null,
  callToActionList: null,
};

export default ContentBlock;
